export default __webpack_public_path__ + "static/media/device-on.18cd846f.svg";